module.exports = "<p>\n  scora-modal-module works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-modal-module/scora-modal-module.component.html
// module id = 1033
// module chunks = 6